import { render, staticRenderFns } from "./SendIndividualMessage.vue?vue&type=template&id=39318362&scoped=true&"
import script from "./SendIndividualMessage.vue?vue&type=script&lang=js&"
export * from "./SendIndividualMessage.vue?vue&type=script&lang=js&"
import style0 from "./SendIndividualMessage.vue?vue&type=style&index=0&id=39318362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39318362",
  null
  
)

export default component.exports